import { Box, Skeleton, Stack } from "@mui/material";

/**
 * SecretsSkeleton — table rows matching the Secrets tab column widths.
 */
export function SecretsSkeleton(): React.ReactElement {
  const cardSx = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    p: 2.5,
    bgcolor: "background.paper",
  };

  return (
    <Stack spacing={2.5}>
      {/* Inherited secrets card */}
      <Box sx={cardSx}>
        <Skeleton variant="text" width={130} height={16} sx={{ mb: 2 }} />
        <Stack
          direction="row"
          spacing={2}
          sx={{ pb: 1.5, borderBottom: "1px solid", borderColor: "divider" }}
        >
          <Skeleton variant="text" width="30%" height={14} />
          <Skeleton variant="text" width="30%" height={14} />
          <Skeleton variant="text" width={60} height={14} />
        </Stack>
        {[1, 2].map((i) => (
          <Stack
            key={i}
            direction="row"
            spacing={2}
            sx={{
              py: 1.5,
              borderBottom: i < 2 ? "1px solid" : "none",
              borderColor: "divider",
            }}
          >
            <Skeleton variant="text" width="30%" height={16} />
            <Skeleton variant="text" width="30%" height={16} />
            <Skeleton variant="rounded" width={50} height={20} />
          </Stack>
        ))}
      </Box>

      {/* Stack secrets card */}
      <Box sx={cardSx}>
        <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
          <Skeleton variant="text" width={120} height={16} />
          <Skeleton
            variant="rounded"
            width={90}
            height={28}
            sx={{ borderRadius: "8px" }}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          sx={{ pb: 1.5, borderBottom: "1px solid", borderColor: "divider" }}
        >
          <Skeleton variant="text" width="25%" height={14} />
          <Skeleton variant="text" width="25%" height={14} />
          <Skeleton variant="text" width={80} height={14} />
        </Stack>
        {[1, 2, 3].map((i) => (
          <Stack
            key={i}
            direction="row"
            spacing={2}
            sx={{
              py: 1.5,
              borderBottom: i < 3 ? "1px solid" : "none",
              borderColor: "divider",
            }}
          >
            <Skeleton variant="text" width="25%" height={16} />
            <Skeleton variant="text" width="25%" height={16} />
            <Skeleton variant="text" width={80} height={16} />
          </Stack>
        ))}
      </Box>
    </Stack>
  );
}

export default SecretsSkeleton;
